import React, {Component} from 'react';
import chrono_logo from "../img/logo_big_shadow.png";
import $ from "jquery";
import {Redirect} from "react-router";
import {withTranslation} from "react-i18next";
import {withCookies} from 'react-cookie';

const cardContainer = {
    maxWidth: 500,
    padding: "40px 40px 10px 40px",
    backgroundImage: "linear-gradient(to right, #F7F7F7 0, #848484 100%)",
    margin: "0 auto 25px",
    marginTop: 50,
    borderRadius: 20,
    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.3)"
};
const title = {
    textAlign: "center",
    fontFamily: "Iceland",
    fontWeight: "bold",
    fontSize: 30,
    marginBottom: 30,
    color: "#ed2126",
    bottom: 0
};
const countDownStyle = {
    textAlign: "center",
    fontFamily: "Iceland",
    fontWeight: "bold",
    fontSize: 45,
    marginBottom: 30,
    color: "#ed2126",
    bottom: 0
};
const urlStyle = {
    textAlign: "center",
    fontFamily: "Iceland",
    fontWeight: "bold",
    fontSize: 25,
    marginBottom: 30,
    color: "#ed2126",
    bottom: 0,
    cursor: "pointer",
};

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class LandingPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            eventDate: 0,
            eventLength: 0,
            eventName: "",
            sessionType: "",
            sessionName: "",
            sessionActive: -1,
            eventShareCode: "",
            sessionOver: false,
            countDown: "---",
            message: "",
            redirect: null,
            delayed: false,
            now: new Date().getTime(),
        };

        this.handleTimeCountdown = this.handleTimeCountdown.bind(this);
        this.padDigits = this.padDigits.bind(this);
        this.handleGoToDash = this.handleGoToDash.bind(this);
    }

    componentDidMount() {
        $(".loading").fadeIn();
            this.setState({
                now: new Date().getTime(),
            });
        const helper = this;
        $.ajax({
            type: 'GET',
            url: serverIP + ":" + backendPort + '/dashboard/getDataByShareID',
            headers: {
                'eventShareCode': helper.props.match.params.eventShareCode,
            },
            success: function (data) {
                if (data && Object.keys(data).length > 0 && data.active < 3) {
                    const date = helper.state.now / 1000;
                    const eventDate = (data.start_timestamp ? data.start_timestamp : data.scheduled_start_timestamp);

                    helper.props.cookies.set("authToken", data.token)

                    helper.setState({
                        eventID: data.event_id,
                        sessionID: data.session_id,
                        eventDate: eventDate,
                        eventLength: data.session_length,
                        eventName: data.event_title,
                        sessionType: data.session_type,
                        sessionName: data.session_name,
                        sessionActive: data.active,
                        eventShareCode: helper.props.match.params.eventShareCode,
                    }, () => {
                        if (date > eventDate && date < (eventDate + data.session_length) && data.active === 2) {
                            helper.setState({
                                redirect: true,
                                eventDate: eventDate,
                                countDown: -1,
                            });
                        } else {
                            helper.setState({
                                redirect: false,
                            });
                            helper.handleTimeCountdown(eventDate);
                        }
                    });
                } else {
                    helper.setState({
                        message: this.props.t("noActiveSessions"),
                        countDown: 0,
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        }).done(function () {
            $(".loading").fadeOut();
        });
    }

    handleTimeCountdown(start_timestamp) {
        // Set the date we're counting down to
        const countDownDate = new Date((start_timestamp * 1000)).getTime();
        // Update the count down every 1 second
        const x = setInterval(() => {
            // Get todays date and time
            const now = this.state.now;

            // Find the distance between now and the count down date
            const distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // If the count down is finished, write some text
            if (distance < 0) {
                if (this.state.sessionActive === 1) {
                    this.setState({
                        delayed: true,
                    });
                } else {
                    clearInterval(x);
                    this.setState({
                        countDown: -1,
                        redirect: true,
                    });
                }
            } else {
                // Display the result in the element with id="demo"
                this.setState({
                    countDown: (days + " " + this.props.t("days") + ", " + this.padDigits(hours, 2) + "h " + this.padDigits(minutes, 2) + "m " + this.padDigits(seconds, 2) + " s"),
                });
            }
        }, 1000);

    }

    padDigits(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join('0') + number;
    }

    handleGoToDash(e) {
        e.preventDefault();
        this.setState({
            redirect: true,
        });
    }

    render() {
        if (this.state.redirect === null) {
            return null;
        }
        if (this.state.redirect) {
            return (
                <Redirect
                    to={{
                        pathname: "/dashboard",
                        state: {
                            isGuest: true,
                            privileges: [],
                            eventID: this.state.eventID,
                            sessionID: this.state.sessionID,
                            eventShareCode: this.props.match.params.eventShareCode,
                        }
                    }}
                />
            );
        } else {
            return (
                <div>
                    <div className="loading">
                        <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                    </div>
                    <div className={"container w3-animate-zoom"}>
                        <div style={cardContainer}>
                            <div className={"text-center"}>
                                <img width={"70%"} src={chrono_logo} alt={"LOGO"}/>
                            </div>
                            <h2 className={"text-center"} style={title}>{this.state.eventName}</h2>
                            <h4 className={"text-center"} style={title}>{this.state.sessionName}</h4>
                            <hr/>
                            <h5 className={"text-center"} style={countDownStyle}>
                                {this.state.delayed ? (
                                    <div>
                                        <p style={urlStyle}>{this.props.t("delayed").toUpperCase()}</p>
                                        <p style={urlStyle}>{this.props.t("pleaseWait")}</p>
                                    </div>
                                ) : (
                                    this.state.message.length > 0 ? (
                                        <p style={urlStyle}>{this.state.message}</p>
                                    ) : (
                                        <div>
                                            <p style={urlStyle}>{this.props.t("startsIn")}</p>
                                            {this.state.countDown}
                                        </div>
                                    )
                                )}
                            </h5>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(LandingPage));